import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formFilter'
})
export class FormFilterPipe implements PipeTransform {

  
  transform(items: any[], field: string, value: string): any[] {
    if (!items) {
      return [];
    }
    if (!field || !value) {
      return items;
    }    
    if(value == "true" || value == "false"){
      return items.filter(singleItem => singleItem.controls[field].value.toString() == value);

    }else{
      return items.filter(singleItem => singleItem.controls[field].toLowerCase().includes(value.toLowerCase()));

    }
  }

}
